module.exports = __webpack_public_path__ + "static/instagram-grey-d0930c3cfcda0d1fc2a6dab79bfe681b.png";